import jwt from 'jsonwebtoken';

export default {
  microserviceToken(state) { return state.microserviceToken; },
  whizeoToken(state) { return state.whizeoToken; },
  decodedWebeoToken(_state, getters) {
    return getters.microserviceToken && jwt.decode(getters.microserviceToken);
  },
  decodedWhizeoToken() {
    return localStorage.getItem('whizeoToken') && jwt.decode(localStorage.getItem('whizeoToken'));
  },
  loggedIn(_state, getters) {
    if (!getters.decodedWebeoToken) return false;
    const { exp } = getters.decodedWebeoToken;
    return Date.now() < exp * 1000;
  },
  hasValidWhizeoToken(_state, getters) {
    if (!localStorage.getItem('whizeoToken')) return false;
    const { exp } = getters.decodedWhizeoToken;
    return Date.now() < exp * 1000;
  },
  isImpersonator(_state, getters) {
    if (!getters.decodedWebeoToken) return false;
    const { Impersonator } = getters.decodedWebeoToken;
    return Impersonator === 'true';
  },
  userPermissions(_state, getters) {
    const { permissions } = getters.decodedWebeoToken;
    if (!getters.decodedWebeoToken || !permissions) return [];
    if (Array.isArray(permissions)) return permissions;

    return [permissions];
  },
  isClient(_state, getters) {
    if (!getters.decodedWebeoToken) return false;
    const { ClientId } = getters.decodedWebeoToken;
    return Boolean(ClientId);
  },
  clientFirstName(state) {
    return state.userInfo && state.userInfo.firstName;
  },
  clientDomain(state) {
    return state.clientInfo && state.clientInfo.domain;
  },
  clientName(state) {
    return state.clientInfo && state.clientInfo.name;
  },
  hasClientFeature(state) {
    return (feature) => state.userInfo && state.userInfo.features.includes(feature);
  },
  sidenavCollapsed(state) { return state.sidenavCollapsed; },
  userInfo(state) { return state.userInfo; },
  clientInfo(state) { return state.clientInfo; },
  showTutorial(state) { return state.showTutorial; },
  theme(state) { return state.theme; },
  isLightTheme(state) { return state.theme === 'light-theme'; },
};
